import { oneOfNessieResponsivePropType, spacingNessieResponsivePropType } from "./propTypes";
import { nessiePropCheckerWrapper } from "./nessiePropCheckerWrapper";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var Space = function Space(_ref) {
  var children = _ref.children,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? "block" : _ref$kind,
      size = _ref.size;
  var props = {};

  if (kind === "inline") {
    props.marginRight = size;
  }

  if (kind === "block") {
    props.marginBottom = size;
  }

  return _jsx("div", {
    sx: kind === "inline" ? {
      marginRight: size
    } : kind === "block" ? {
      marginBottom: size
    } : undefined,
    children: children
  });
};
Space.displayName = "Space";
Space.nessiePropTypes = {
  kind: oneOfNessieResponsivePropType(["inline", "block"]),
  size: spacingNessieResponsivePropType
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  Space = nessiePropCheckerWrapper(Space);
}
//# sourceMappingURL=Space.js.map